import styled from 'styled-components'

export const WrapperComponent = styled.div`
    overflow-y: auto;
    height: 100%;

    ::-webkit-scrollbar {
        width: 7px;
        background-color: #485268;
    }

    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    ::-webkit-scrollbar-thumb {
        background: #888;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
`

export const Wrapper = styled.div`
    font-family: SourceSansPro-Semibold, Arial, Helvetica Neue, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 600;
    display: grid;
    height: 100%;
    grid-template-rows: ${props => props.templateRow};
    grid-template-columns: ${props => props.templateCol};
    grid-template-areas: ${props => props.templateAreas};
    color: ${props => (props.theme === 'light' ? '#364159' : '#BAC0CB')};
    div {

        h3 {
            font-size: 10px;
            line-height: 12px;
            width: fit-content;
            color: ${props => (props.theme === 'light' ? '#364159' : '#BAC0CB')};
        }

        p {
            font-size: 24px;
            line-height: 24px;
            color: ${props => (props.theme === 'light' ? '#364159' : '#FFFFFF')};
            margin-bottom: 4px;
            span {
                font-size: 16px;
                margin-left: 4px;
            }
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 100%;
            padding-right: 1px;
        }
    }

`
